export default "__VITE_ASSET__ChDdac_p__"